import { HttpBackend, HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable, of as observableOf } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { ChatDeskService } from '../chat-desk/chat-desk.service';

@Injectable({
  providedIn: 'root',
})
export class ConfigService {
  private httpClient = inject(HttpClient);
  private chatDeskService = inject(ChatDeskService);

  isLoaded: Observable<boolean>;
  public config: any;

  constructor(handler: HttpBackend) {
    this.httpClient = new HttpClient(handler);
  }

  getConfig(): Observable<{}> {
    return this.httpClient.get(environment.configPath).pipe(
      tap((response) => {
        this.config = response;
        this.isLoaded = observableOf(true);
      })
    );
  }

  getProperty<T>(name: string): T {
    return this.config[name];
  }

  getArrayProperty(name: string): string[] {
    return this.config[name];
  }

  loadConfig(): Observable<any> {
    return this.httpClient.get(environment.configPath).pipe(
      map((data) => {
        this.config = data;
        return data;
      })
    );
  }

  initiateChatDesk() {
    this.loadConfig().subscribe((config) => {
      if (config && config.CHAT_DESK_URL) {
        this.chatDeskService.loadFreshChatScript(document, 'Freshchat-js-sdk', config.CHAT_DESK_URL);
      }
    });
  }
}
